import React from 'react';

function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={onToggle}
      className="theme-toggle-button"
      aria-label="Toggle dark/light mode"
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <i className={isDark ? 'bi bi-sun-fill theme-icon' : 'bi bi-moon-fill theme-icon'} />
    </button>
  );
}

export default ThemeToggle;
